module.exports = __webpack_public_path__ + "static/media/svg-sprite.fb02a23e.svg";